import { IconType } from '../index';

const IconCedroAustraliano = (props: IconType) => {
  return (
    <svg
      width="auto"
      height="26"
      viewBox="0 0 17 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.99585 0H6.42974C2.88442 0 0 2.88431 0 6.42974V20.694C0 23.6809 3.11384 26.9009 6.57063 26.9174V30.9193C6.57063 31.5161 7.05451 32 7.65131 32H8.83193C9.42872 32 9.9126 31.5161 9.9126 30.9193V26.9009C13.3116 26.9009 16.4256 23.6599 16.4256 20.6939V6.42974C16.4256 2.88431 13.5412 0 9.99585 0ZM7.72956 10.9623C7.88159 11.0384 8.04719 11.0764 8.2128 11.0764C8.3784 11.0764 8.544 11.0384 8.69603 10.9623L14.2643 8.17821V11.111L8.2128 14.1367L2.16135 11.111V8.17821L7.72956 10.9623ZM2.16135 13.5273L7.72967 16.3114C7.8817 16.3874 8.0473 16.4255 8.2129 16.4255C8.37851 16.4255 8.54411 16.3874 8.69613 16.3114L14.2645 13.5273V16.4601L8.2128 19.4857L2.16135 16.4601V13.5273ZM6.42974 2.16124H9.99585C12.1308 2.16124 13.9045 3.73678 14.2158 5.78618L8.2128 8.78761L2.20983 5.78618C2.5211 3.73678 4.2949 2.16124 6.42974 2.16124ZM9.99585 24.9625H6.42974C4.07607 24.9625 2.16124 23.0477 2.16124 20.694V18.8763L7.72956 21.6604C7.88159 21.7365 8.04719 21.7745 8.2128 21.7745C8.3784 21.7745 8.544 21.7365 8.69603 21.6604L14.2643 18.8763V20.694C14.2642 23.0475 12.3494 24.9625 9.99585 24.9625Z"
        fill={props.color}
      />
    </svg>
  );
};

IconCedroAustraliano.defaultProps = {
  color: 'black',
} as IconType;

export default IconCedroAustraliano;
